<template>
  <div class="sys-userform-view" :style="{ padding: IsDetailUserForm ? '0' : '24px' }">
    <template v-if="IsDataInitComplete">
      <div v-show="IsShowUserForm && Config.scrollEl">
        <CgImportTemplate
          ref="ListMicroFrontView"
          v-if="ListTemplateIsExists"
          v-show="ListTemplateIsShow"
          :entry="CurUserForm.ListTemplateEntry"
          :config="Config"
          :name="'UserFormID_' + UserFormID + '_ListMicroFrontView'"
          :autoLoad="false"
          @onMount="OnMount"
        />
        <CgImportTemplate
          ref="EditMicroFrontView"
          v-if="EditTemplateIsExists"
          v-show="EditTemplateIsShow"
          :entry="CurUserForm.EditTemplateEntry"
          :config="Config"
          :name="'UserFormID_' + UserFormID + '_EditMicroFrontView'"
          :autoLoad="false"
          @onMount="OnMount"
        />
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: "SysView",
  inject: ["userForm"],
  data() {
    return {
      IsDataInitComplete: true,
      IsShowUserForm: true,
      EditTemplateEntry: "",
      ListTemplateEntry: "",
      Config: {
        scrollEl: null,
      },
    };
  },
  computed: {
    CurUserForm() {
      return this.userForm;
    },
    CurViewState() {
      return this.CurUserForm.CurViewState;
    },
    ViewState() {
      return this.CurUserForm.Cfg.ViewState;
    },
    UserFormID() {
      return this.CurUserForm.UserFormID;
    },
    IsDetailUserForm() {
      return this.CurUserForm.Type === "DetailUserForm";
    },
    SysViewState() {
      return this.$root.qiankunProps?.viewState;
    },
    ListTemplateIsExists() {
      return (
        typeof this.SysViewState === "undefined" ||
        this.SysViewState?.includes(this.ViewState.RecList)
      );
    },
    ListTemplateIsShow() {
      return (
        this.CurViewState === this.ViewState.RecList ||
        (this.SysViewState?.includes(this.ViewState.RecList) ?? false)
      );
    },
    EditTemplateIsExists() {
      return (
        typeof this.SysViewState === "undefined" ||
        !this.SysViewState?.includes(this.ViewState.RecList)
      );
    },
    EditTemplateIsShow() {
      return (
        this.CurViewState !== this.ViewState.RecList ||
        (Array.isArray(this.SysViewState) &&
          !this.SysViewState?.includes(this.ViewState.RecList))
      );
    },
  },
  created() {
    this.MountedCount = 0;
  },
  mounted() {
    this.$nextTick(() => {
      this.Config.scrollEl = document.querySelector(".cg-main-warp") || window;
    });
  },
  methods: {
    OnMount() {
      this.MountedCount++;
      if (this.MountedCount >= 2 || typeof this.SysViewState === "string") {
        this.$emit("onMount", this.CurUserForm);
      }
    },
    LoadUserFormView() {

      this.MountedCount = 0;

      this.$nextTick(()=>{
        this.$refs.ListMicroFrontView?.LoadPage();
        this.$refs.EditMicroFrontView?.LoadPage();
      });
    },
  },
};
</script>

<style scoped lang="less">
.cg-main-warp .sys-userform-view {
  padding: 24px;
  // overflow: hidden;
}
.userform-enter {
  transform: translate(20%, 0);
  opacity: 0;
}
.userform-enter-active {
  transition: all 0.4s ease-out;
}
.userform-enter-to {
  transform: translate(0%, 0);
  opacity: 1;
}
</style>
